import Img01 from "../images/Landing/img01.png";
import Img02 from "../images/Landing/img02.png";
import Img03 from "../images/Landing/img03.png";
import Img04 from "../images/Landing/img04.png";
import Img05 from "../images/Landing/img05.png";
import Img06 from "../images/Landing/img06.png";
import Img07 from "../images/Landing/img07.png";
import Img08 from "../images/Landing/img08.png";
import Img09 from "../images/Landing/img09.png";
import Img10 from "../images/Landing/img10.png";
import Img11 from "../images/Landing/img11.png";

import AIPersona01 from "../images/Landing/AIPersona01.png";
import AIPersona02 from "../images/Landing/AIPersona02.png";
import AIPersona03 from "../images/Landing/AIPersona03.png";

import Iconfield01 from "../images/Landing/Iconfield01.svg";
import Iconfield02 from "../images/Landing/Iconfield02.svg";
import Iconfield03 from "../images/Landing/Iconfield03.svg";
import Iconfield04 from "../images/Landing/Iconfield04.svg";
import Iconfield05 from "../images/Landing/Iconfield05.svg";
import Iconfield06 from "../images/Landing/Iconfield06.svg";
import Iconfield07 from "../images/Landing/Iconfield07.svg";
import Iconfield08 from "../images/Landing/Iconfield08.svg";
import Iconfield09 from "../images/Landing/Iconfield09.svg";

import ImgAIModerator from "../images/Landing/imgAIModerator.png";
import ImgAIExpert from "../images/Landing/imgAIExpert.png";

import ImgProposal01 from "../images/Landing/imgProposal01.png";
import ImgProposal02 from "../images/Landing/imgProposal02.png";

import ImgMarketing01 from "../images/Landing/imgMarketing01.png";
import ImgMarketing02 from "../images/Landing/imgMarketing02.png";
import ImgMarketing03 from "../images/Landing/imgMarketing03.png";

import ImgLanding from "../images/Landing/img_landing.png";
import ImgLanding01 from "../images/Landing/img_landing01.png";
import ImgLanding02 from "../images/Landing/img_landing02.png";
import ImgLanding03 from "../images/Landing/img_landing03.png";
import ImgLanding04 from "../images/Landing/img_landing04.png";
import ImgLanding05 from "../images/Landing/img_landing05.png";
import ImgLanding06 from "../images/Landing/img_landing06.png";
import ImgLanding07 from "../images/Landing/img_landing07.png";
import ImgLanding08 from "../images/Landing/img_landing08.png";
import ImgLanding09 from "../images/Landing/img_landing09.png";
import ImgLanding10 from "../images/Landing/img_landing10.png";
import ImgLanding11 from "../images/Landing/img_landing11.png";
import ImgLanding12 from "../images/Landing/img_landing12.png";
import ImgLanding13 from "../images/Landing/img_landing13.png";
import ImgLanding14 from "../images/Landing/img_landing14.png";
import ImgLanding15 from "../images/Landing/img_landing15.png";
import ImgLanding16 from "../images/Landing/img_landing16.png";

import Kyunghee from "../images/Landing/KyungHeeUni.png";
import dcbXalmaden from "../images/Landing/dcbXalmaden.png";
import dcbXbnk from "../images/Landing/dcbXbnk.png";
import hyerica from "../images/Landing/hyerica_logo.png";
import inu from "../images/Landing/inu_logo.png";
import ImgLandingLogo00 from "../images/Landing/busan_design_logo.png";
import ImgLandingLogo01 from "../images/Landing/kyunghyee_university.png";
import ImgLandingLogo02 from "../images/Landing/seoul_innovation.png";
import ImgLandingCarouselLogo from "../images/Landing/carousel_logo.png";
import ImgLandingCarouselLogo2 from "../images/Landing/carousel_logo2.png";

const Landingimages = {
  dcbXalmaden,
  Kyunghee,
  ImgLandingLogo00,
  ImgLandingLogo01, 
  ImgLandingLogo02,
  ImgLandingCarouselLogo,
  ImgLandingCarouselLogo2,
  dcbXbnk,
  hyerica,
  inu,
  Img01,
  Img02,
  Img03,
  Img04,
  Img05,
  Img06,
  Img07,
  Img08,
  Img09,
  Img10,
  Img11,

  AIPersona01,
  AIPersona02,
  AIPersona03,

  Iconfield01,
  Iconfield02,
  Iconfield03,
  Iconfield04,
  Iconfield05,
  Iconfield06,
  Iconfield07,
  Iconfield08,
  Iconfield09,

  ImgAIModerator,
  ImgAIExpert,

  ImgProposal01,
  ImgProposal02,

  ImgMarketing01,
  ImgMarketing02,
  ImgMarketing03,

  ImgLanding,
  ImgLanding01,
  ImgLanding02,
  ImgLanding03,
  ImgLanding04,
  ImgLanding05,
  ImgLanding06,
  ImgLanding07,
  ImgLanding08,
  ImgLanding09,
  ImgLanding10,
  ImgLanding11,
  ImgLanding12,
  ImgLanding13,
  ImgLanding14,
  ImgLanding15,
  ImgLanding16,
};

export default Landingimages;
